// Read-only client for /api/search-tags. Search tags are reference data defined in code (C# manifest)
// and seeded by the ReferenceDataReconciler — the controller exposes GET only, so there is no
// create/update/remove here. Routed through axios so the Auth0 bearer token is attached on deployed.
import axios from "axios";

export interface SearchTag {
	id: string;
	label: string;
	description?: string | null;
	color?: string | null;
	triggerKeywords: string[];
	defaultContentTypeIds: string[];
	sortOrder: number;
	isActive: boolean;
}

const base = "/api/search-tags";

export const searchTagsClient = {
	list: async (includeInactive = true): Promise<SearchTag[]> => {
		const res = await axios.get<SearchTag[]>(base, { params: { includeInactive } });
		return res.data ?? [];
	},

	get: async (id: string): Promise<SearchTag> => {
		const res = await axios.get<SearchTag>(`${base}/${encodeURIComponent(id)}`);
		return res.data;
	},
};
